module.exports = __webpack_public_path__ + "static/media/combined-shape2.77b88c1b.svg";